import React, { Fragment } from 'react'
import '../lib/CustomEvent.polyfill.js'
import { StaticQuery, graphql } from 'gatsby'
import styled, { ThemeProvider } from 'styled-components'
import { Flex, Box } from 'rebass'
import Helmet from 'react-helmet'
import { StripeProvider } from 'react-stripe-elements'
import CitygateTheme from '../theme/'
import HeaderContracted from '../components/HeaderContracted'
import HeaderExpanded from '../components/HeaderExpanded'
import HeaderMinimal from '../components/HeaderMinimal'
import RouterPrimaryExpanded from '../components/RouterPrimaryExpanded'
import RouterSecondaryExpanded from '../components/RouterSecondaryExpanded'
import AccidentModal from '../components/AccidentModal'
import EventHypeStrip from './EventHypeStrip/index.jsx'
import NewsStrip from './NewsStrip/index.jsx'
import Footer from '../components/Footer'
import A11yNav from '../components/A11yNav'
import ContentDimmer from '../components/ContentDimmer'
import { media } from '../utils/style'
import { sortBy } from 'lodash'
import debug from 'debug'
import { isVan, isCar } from '../../lib/category-matcher.js'
import Headroom from 'react-headroom'

const getSections = (type) => [
  {
    label: 'Cars',
    slug: `cars${type === 'minimal' ? '/used' : ''}`,
    root: type !== 'minimal'
  },
  { label: 'Vans', slug: `vans${type === 'minimal' ? '/used' : ''}` },
  { label: 'Leasing & Fleet', slug: 'fleet-and-business' },
  { label: 'Rental', slug: 'vwfs-rent-a-car' },
  { label: 'Locations', slug: 'locations' },
  { label: 'Careers', slug: 'careers' },
  { label: 'Blog', slug: 'blog' },
  { label: 'About us', slug: 'about-us' },
  { label: 'Motability', slug: 'motability' },
  { label: 'Finance', slug: 'finance' },
  { label: 'FAQs', slug: 'faqs' }
]

const sections = getSections()
const minimalSections = getSections('minimal')

const categorySubSections = {
  cars: [
    { label: 'New', slug: '/cars/new' },
    { label: 'Used', slug: '/cars/used' },
    {
      label: 'Sell Your Vehicle',
      slug: '/cars/sell-your-car/',
      isHighlighted: true
    },
    { label: 'Offers', slug: '/cars/offers' },
    { label: 'Bodyshop', slug: '/bodyshop' },
    { label: 'Servicing', slug: '/servicing' }
  ],
  vans: [
    { label: 'New', slug: '/vans/new' },
    { label: 'Used', slug: '/vans/used' },
    { label: 'Offers', slug: '/vans/offers' },
    { label: 'Bodyshop', slug: '/bodyshop' },
    { label: 'Servicing', slug: '/servicing' }
  ]
}

const SmallToGiantScreenOnly = styled.div`
  display: block;
  ${media.GiantScreenUp`
    display: none;
  `};
`
const GiantScreenUp = styled.div`
  display: none;
  ${media.GiantScreenUp`
    display: block;
  `};
`

const HelmetComponent = (props) => (
  <Fragment>
    <Helmet
      title="The UK's leading Volkswagen, ŠKODA, SEAT, CUPRA & Kia dealer"
      titleTemplate="%s | Citygate"
      meta={[
        {
          name: 'description',
          content: `The UK's leading Volkswagen, ŠKODA, SEAT, CUPRA & Kia dealer with ${props.count} Locations across London & the South East.`
        },
        {
          property: 'og:title',
          content: 'New and Used ŠKODA and VW Dealers'
        },
        { property: 'og:type', content: 'website' },
        {
          property: 'og:url',
          content: `${process.env.GATSBY_SITE_URL}${props.location.pathname}`
        },
        {
          property: 'og:description',
          content: `The UK's leading Volkswagen, ŠKODA, SEAT, CUPRA & Kia dealer with ${props.count} Locations across London & the South East.`
        },
        {
          property: 'og:image',
          content: `${process.env.GATSBY_SITE_URL}/image/citgate.png`
        },
        { property: 'twitter:card', content: 'summary_large_image' },
        { property: 'twitter:site', content: '@CitygateCars' },
        { property: 'twitter:creator', content: '@CitygateCars' }
      ]}
      link={[
        {
          rel: 'preload',
          href: '/fonts/5423411/41c8162d-c2a6-49b0-8139-8bebab187588.woff2',
          as: 'font',
          crossOrigin: 'anonymous'
        },
        {
          rel: 'preload',
          href: '/fonts/5423483/ec598369-4d91-4a16-9db3-6654f68d3c28.woff2',
          as: 'font',
          crossOrigin: 'anonymous'
        },
        {
          rel: 'preload',
          href: '/fonts/5423483/MarkPro-Medium.woff2',
          as: 'font',
          crossOrigin: 'anonymous'
        },
        {
          rel: 'canonical',
          href: `${process.env.GATSBY_SITE_URL}${props.location.pathname}`
        }
      ]}
      style={[
        {
          cssText: `
            @font-face {
              font-family: 'FFMark';
              font-weight: 600;
              font-display: fallback;
              src: url('/fonts/5423411/8706c0b6-b423-44f7-ae1a-dd0aabd8a542.eot');
              src: url('/fonts/5423411/8706c0b6-b423-44f7-ae1a-dd0aabd8a542.eot?#iefix')
                  format('eot'),
                url('/fonts/5423411/41c8162d-c2a6-49b0-8139-8bebab187588.woff2')
                  format('woff2'),
                url('/fonts/5423411/4fe94f2e-7892-4785-9663-0350a7adf8c0.woff')
                  format('woff'),
                url('/fonts/5423411/3a7daddb-0a78-4734-a699-6fe08d0e8b99.ttf')
                  format('truetype');
            }
            @font-face {
              font-family: 'FFMark';
              font-weight: 400;
              font-display: fallback;
              src: url('/fonts/5423483/230b3c63-b497-421b-ae7d-182024bef8ac.eot');
              src: url('/fonts/5423483/230b3c63-b497-421b-ae7d-182024bef8ac.eot?#iefix')
                  format('eot'),
                url('/fonts/5423483/ec598369-4d91-4a16-9db3-6654f68d3c28.woff2')
                  format('woff2'),
                url('/fonts/5423483/90214997-3760-4b80-a23b-fec02ab55fac.woff')
                  format('woff'),
                url('/fonts/5423483/118e930e-1f56-4131-aee9-236212c0a10b.ttf')
                  format('truetype');
            }
            @font-face {
              font-family: 'FFMark';
              font-weight: 500;
              font-display: fallback;
              src: url('/fonts/5423483/MarkPro-Medium.woff2') format('woff2');
            }
            * {
              box-sizing: border-box;
              -webkit-font-smoothing: antialiased;
              -moz-osx-font-smoothing: grayscale;
            }

            html {
              overscroll-behavior-x: none;
              overflow-x: hidden;
            }

            ::selection {
              background: rgba(0, 173, 238, 1);
              color: white;
              text-shadow: none;
            }

            h2, h3, h4, h5, h6 {
              color: ${CitygateTheme.colors.blue};
              font-weight: 600;
            }

            p {
              a {
                color: ${CitygateTheme.colors.electric_blue};
              }
            }

            a {
              transition: color 0.5s ${CitygateTheme.ease.ease_out_expo};
            }

            a:hover {
              color: ${CitygateTheme.colors.grey};
            }

            .no-scroll {
              overflow: hidden;
              position: fixed;
              width: 100%;
            }

            input::-ms-clear {
              display: none;
            }

            #onetrust-consent-sdk {
              overflow: hidden;
            }
          `
        }
      ]}
    />
    {props.discoverable === false && (
      <Helmet meta={[{ name: 'robots', content: 'noindex' }]} />
    )}
  </Fragment>
)

class Template extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      stripe: null
    }
  }

  componentDidMount() {
    if (window.Stripe) {
      this.setState({
        stripe: window.Stripe(`${process.env.GATSBY_STRIPE_PUBLISHABLE}`)
      })
    } else {
      document.querySelector('#stripe-js').addEventListener('load', () => {
        this.setState({
          stripe: window.Stripe(`${process.env.GATSBY_STRIPE_PUBLISHABLE}`)
        })
      })
    }
  }

  render() {
    debug('layout')(this.props.location.pathname)
    const {
      number: phoneNumber = '0330 108 8020',
      class: calltracksClass = 'calltracks_global-general'
    } = this.props.telephoneData || {}
    const isHome = this.props.location.pathname === '/'

    const isVans =
      isVan(this.props.category) || /^\/vans/.test(this.props.location.pathname)

    const isCars =
      isCar(this.props.category) || /^\/cars/.test(this.props.location.pathname)

    const subSections = isVans
      ? categorySubSections.vans
      : categorySubSections.cars
    return (
      <StripeProvider stripe={this.state.stripe}>
        <ThemeProvider theme={CitygateTheme}>
          <StaticQuery
            query={graphql`
              query LayoutQuery {
                brandList: allMakeCatfish(
                  filter: { state: { eq: "Published" } }
                ) {
                  edges {
                    node {
                      name
                      slug
                      category
                      order
                    }
                  }
                }
                globalEvents: allGlobalEventCatfish {
                  edges {
                    node {
                      _id
                      images
                      headline
                      eventStartDate
                      eventEndDate
                      locationUrl
                      hypeStripColour
                    }
                  }
                }
                newsStrip: allNewsStripCatfish {
                  edges {
                    node {
                      _id
                      dismissId
                      items {
                        headline
                        description
                        callToActionText
                        callToActionLink
                      }
                    }
                  }
                }
                footerLocations: allDealershipCatfish(
                  sort: { shortName: ASC }
                ) {
                  edges {
                    node {
                      slug
                      shortName
                    }
                  }
                }
              }
            `}
            render={(data) => {
              const filteredBrands =
                data.brandList &&
                data.brandList.edges
                  .map(({ node }) => node)
                  .filter(
                    (brand) =>
                      (isVans && isVan(brand.category)) ||
                      (!isVans && isCar(brand.category))
                  )

              const brands = sortBy(filteredBrands, 'order', 'desc')
              const locations = data.footerLocations.edges.map(
                ({ node }) => node
              )

              const events =
                data &&
                data.globalEvents &&
                data.globalEvents.edges &&
                data.globalEvents.edges.length > 0 &&
                data.globalEvents.edges
                  .map(({ node }) => node)
                  .filter(
                    (node) =>
                      !node._id.includes('forceCreateAllGlobalEventCatfish')
                  )
              const news =
                data &&
                data.newsStrip &&
                data.newsStrip.edges &&
                data.newsStrip.edges.length > 0 &&
                data.newsStrip.edges
                  .map(({ node }) => node)
                  .filter(
                    (node) =>
                      !node._id.includes('forceCreateAllNewsStripCatfish')
                  )

              return (
                <Fragment>
                  <HelmetComponent {...this.props} count={locations.length} />
                  <A11yNav />
                  <ContentDimmer />
                  <AccidentModal />
                  {events && events.length > 0 && (
                    <EventHypeStrip {...events[0]} />
                  )}

                  <SmallToGiantScreenOnly>
                    <HeaderContracted
                      sections={sections}
                      subSections={subSections}
                      max={3}
                      brands={brands}
                      isCars={isCars}
                      isVans={isVans}
                    />
                  </SmallToGiantScreenOnly>

                  <GiantScreenUp>
                    <Headroom style={{ zIndex: 1000 }}>
                      {this.props.minimalHeader ? (
                        <HeaderMinimal
                          sections={minimalSections}
                          subSections={subSections}
                          highlightNew={this.props.highlightNew}
                          max={3}
                          isCars={isCars}
                          isVans={isVans}
                          phoneNumber={phoneNumber}
                          calltracksClass={calltracksClass}
                        />
                      ) : (
                        <Fragment>
                          <HeaderExpanded
                            location={this.props.location.pathname}
                            phoneNumber={phoneNumber}
                            calltracksClass={calltracksClass}
                          />
                          <RouterPrimaryExpanded
                            sections={sections}
                            max={5}
                            brands={brands}
                            highlightNew={this.props.highlightNew}
                            isCars={isCars}
                            isVans={isVans}
                          />
                          {(isHome || isVans || isCars) && (
                            <RouterSecondaryExpanded
                              sections={subSections}
                              highlightNew={this.props.highlightNew}
                            />
                          )}
                        </Fragment>
                      )}
                    </Headroom>
                  </GiantScreenUp>

                  {news && news.length > 0 && (
                    <NewsStrip
                      items={news[0].items}
                      dismissId={news[0].dismissId}
                    />
                  )}
                  <Flex flexWrap="wrap">
                    <Box width={[1, 1]}>{this.props.children}</Box>
                  </Flex>
                  <Footer
                    locations={locations}
                    socialLinks={this.props.socialLinks}
                  />
                </Fragment>
              )
            }}
          />
        </ThemeProvider>
      </StripeProvider>
    )
  }
}

export default Template
